// src/components/ResetPassword.jsx
import React, { useState } from 'react';
import { useSearchParams, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [password_confirmation, setPasswordConfirmation] = useState('');
  const [message, setMessage] = useState('');
  const token = useParams().token;
  const email = searchParams.get('email');
  const navigate = useNavigate(); 

  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post('http://127.0.0.1:8000/api/reset-password', {
      token,
      email,
      password,
      password_confirmation
    })
    .then(res => {
      setMessage("Password has been reset successfully.");
      setTimeout(() => navigate("/login"), 2000);
    })
    .catch(err => {
      setMessage("Failed to reset password.");
      console.error(err.response?.data);
    });
  };

  return (
    <div className="container mt-5 pt-5">
      <h4>Reset Password</h4>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="New Password"
          value={password}
          className="form-control mb-2"
          onChange={e => setPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={password_confirmation}
          className="form-control mb-2"
          onChange={e => setPasswordConfirmation(e.target.value)}
        />
        <button className="btn btn-success">Reset Password</button>
        {message && <div className="mt-3">{message}</div>}
      </form>
    </div>
  );
};

export default ResetPassword;
